import { SerializedPhoneReport } from '@/reports/index';

export function isNeighborSpoofed(
  reportData: SerializedPhoneReport,
  phoneNumber: string | undefined
) {
  const searchedPhone = reportData.meta?.search_data?.phone_number;
  if (!phoneNumber || !searchedPhone) return false;
  return phoneNumber?.slice(0, 6) === searchedPhone.slice(0, 6) || false;
}
